import { UserSelectors } from '@core/account-data';
import type { InterviewSchedule } from '@core/interview-schedules-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<InterviewSchedule>()(
  'InterviewSchedulesCollection',
  {
    references: makeRef => [makeRef('adminIds', 'admins', UserSelectors.byIds)],
    customActions: adapter => ({
      references: (state, payload: { data: InterviewSchedule[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

export {
  actions as InterviewSchedulesCollectionActions,
  selectors as InterviewSchedulesCollectionSelectors,
  reducer as InterviewSchedulesCollectionReducer,
  namespace as InterviewSchedulesCollectionNamespace,
};
